import { Icon } from "./icon";

interface ForecastItemProps {
  item: types.Forecast;
}

const ForecastItem: React.FC<ForecastItemProps> = ({ item }) => (
  <div className="flex border-b border-white gap-8 py-5 items-center last:!border-b-0">
    <div className="text-white">
      <div className="text-4xl font-bold">{item.weekday}</div>
      <div className="text-3xl">{item.date}</div>
    </div>
    <div className="text-6xl text-[#49A8FF] font-bold flex items-start mt-5">
      <div className="w-[150px] text-end">{item.temp_night}°C</div>
      <img
        className="w-[130px] h-[100px] -mt-10 -ml-5 -mr-5"
        src={`/images/pheno/${item.pheno_night_id}_night.svg`}
        alt={`Pheno ${item.pheno_night_id}_night`}
      />
    </div>
    <div className="text-6xl text-white font-bold flex items-start mt-5">
      <div className="w-[150px] text-end">{item.temp_day}°C</div>
      <img
        className="w-[130px] h-[100px] -mt-10 -ml-5 -mr-5"
        src={`/images/pheno/${item.pheno_day_id}.svg`}
        alt={`Pheno ${item.pheno_day_id}`}
      />
    </div>
    <div className="h-10 border-l border-white"></div>
    <div className="text-4xl text-white flex items-center gap-2">
      <Icon name="sun-up.png" alt="sun-up" className="h-[33px] w-9" />
      <div>{item.sunrise}</div>
    </div>
    <div className="text-4xl text-white flex items-center gap-2">
      <Icon name="sun-down.png" alt="sun-up" className="h-[33px] w-9" />
      <div>{item.sunset}</div>
    </div>
  </div>
);

export default ForecastItem;
